// John Eldhose 20180705
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button, CircularProgress, Divider, Grid, IconButton, InputAdornment, Snackbar, TextField, Typography } from '@material-ui/core';
import { Create, Visibility, VisibilityOff } from '@material-ui/icons';
import { FormattedMessage } from 'react-intl';
//import { resendverify } from '../Api/resendverify';
import NotFound from './NotFound';
import { verify } from '../Api/verify';


class Verify extends Component {

  state = {
    loading: true,
    verify: {},
    showPassword: false,
    password: '',
    showWarning: false,
    Message: '',
    errorMessage: '',
    disableSave: false
  };
  componentWillMount() {
    verify({ x: window.location.search.replace(/^[?]/, '') })
      .then((verify) => {
        if(verify.status === 'true')
          this.setState({ loading: false, verify: verify.verify });
        else
          this.setState({ loading: false });
      })
      .catch((error) => {
        console.log(error);
      })
  }
  handleUserInput(event) {
    this.setState({ [event.target.name]: event.target.value });
  }
  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  }
  handleMouseDownPassword = event => {
    event.preventDefault();
  }
  handleSave = () => {
    this.setState({ disableSave: true });
    verify({
      x: window.location.search.replace(/^[?]/, ''), reset: this.state.password
    })
      .then((verify) => {
        if(verify.status === 'false')
          this.setState({
            errorMessage: verify.verify.recover, disableSave: false
          });
        else
          this.setState({ Message: verify.verify.recover, errorMessage: '' });
      })
      .catch((error) => {
        console.log(error);
      })
  }

  render() {
    if(window.location.search === '')
      return <NotFound />;
    else {
      if(this.state.loading)
        return <CircularProgress />;
      if(!(
        typeof this.state.verify.verify === 'undefined' ||
        this.state.verify.verify === ''
      ))
        return (
          <div style={{ padding: '20px' }}>
            <Typography>
              {this.state.verify.verify} is successfully verified!
            </Typography>
            <p><a href="https://account.carlsonsw.com/login">Sign In</a></p>
          </div>
        );
      else if(!(
        typeof this.state.verify.recover === 'undefined' ||
        this.state.verify.recover === ''
      ))
        return (
          <div style={{ padding: '20px' }}>
            <Typography>
              Please enter a new password for {this.state.verify.recover}
            </Typography>
            <p />
            <div style={{ border: '1px solid silver' }}>
              <TextField
                fullWidth
                label={(this.state.showWarning) ? 'Invalid password' : ''}
                name='password'
                type={this.state.showPassword ? 'text' : 'password'}
                value={this.state.password}
                onChange={(event) => this.handleUserInput(event)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="Toggle password visibility"
                        onClick={this.handleClickShowPassword}
                        onMouseDown={this.handleMouseDownPassword}
                      >
                        {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </div>
            <p />
            <Button
              variant='raised'
              color='primary'
              fullWidth
              style={{ textTransform: 'none' }}
              onClick={this.handleSave}
              disabled={this.state.disableSave}
            >
              Change Password &nbsp; <Create />
            </Button>
            <p />
            <Divider />
            <p />
            <Grid container>
              <Grid item xs={12} sm={12} md={12}>
                <Button component={Link} to='/' fullWidth>
                  <FormattedMessage
                    id='Return to Login'
                    defaultMessage='Return to Login'
                  />
                </Button>
              </Grid>
            </Grid>
            <Snackbar
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              open={this.state.Message !== '' || this.state.errorMessage !== ''}
              message={
                <span>
                  {this.state.Message}
                  <span style={{ color: 'red' }}>
                    {this.state.errorMessage}
                  </span>
                </span>
              }
            />
          </div>
        );
      else
        return <div>The link is expired</div>;
    }
  }
}

export default Verify;



// WEBPACK FOOTER //
// ./src/components/Verify.js